var map = {
	"./all.png": 239,
	"./burger.png": 240,
	"./cart.png": 241,
	"./coffee.png": 242,
	"./icecream.png": 243,
	"./pizza.png": 244,
	"./snacks.png": 245,
	"./softdrinks.png": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;